import React, { useContext, useEffect, useState } from "react";
import { FoundersType, ResultContext } from "../ResultContext";
import { GivenQuestions } from "../constants/Questions";
import { DateTime } from "luxon";
import { LampSuggestion } from "../components/LampSuggestion";

export function StartDateInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);
  const [sameForAllFounders, setSameForAllFounders] = useState(false);

  const currentQuestion = GivenQuestions.find((q) => q.id === questionId) as {
    dependsOn: number;
  };

  const dependsOn = currentQuestion.dependsOn as number;

  const dependsOnResult =
    (result[dependsOn] as {
      name: string;
      type: FoundersType;
    }[]) || [];

  const time = DateTime.now().toFormat("yyyy-LL-dd");

  const foundResult =
    (result[questionId] as string[]) ||
    Array.from({ length: dependsOnResult.length }, () => time);

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = Array.from(
        { length: dependsOnResult.length },
        () => time
      );

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  if (dependsOnResult.length > foundResult.length) {
    const diff = dependsOnResult.length - foundResult.length;
    for (let i = 0; i < diff; i++) {
      foundResult.push(time);
    }
  }

  return (
    <div className="flex flex-column">
      <div className="mb-4">
        <input
          className="mr-3"
          type="checkbox"
          checked={sameForAllFounders}
          onChange={(e) => {
            setSameForAllFounders(e.target.checked);
          }}
        />
        <label>Same for all founders?</label>
      </div>
      {sameForAllFounders && foundResult.length > 0 ? (
        <div>
          <label>Start date</label>
          <div className="flex items-center">
            <input
              type="date"
              value={foundResult[0]}
              onChange={(e) => {
                const copy = { ...result };

                copy[questionId] = foundResult.map(() => {
                  return e.target.value;
                });

                setResult(copy);
              }}
            />
          </div>
        </div>
      ) : null}
      {!sameForAllFounders &&
        dependsOnResult.map((item, index) => {
          return (
            <div className={`${index !== 0 ? "mt-4" : ""}`} key={index}>
              <label>{item.name}</label>
              <div className="flex items-center">
                <input
                  type="date"
                  value={foundResult[index]}
                  onChange={(e) => {
                    const copy = { ...result };

                    copy[questionId] = foundResult.map((it, id) => {
                      if (id === index) {
                        return e.target.value;
                      }

                      return it;
                    });

                    setResult(copy);
                  }}
                />
              </div>
            </div>
          );
        })}
      <LampSuggestion
        text={
          "The further you would go back in time (i.e. backdated vesting), the shorter your future commitment towards your co-founders and the company will be."
        }
      />
    </div>
  );
}
